import qs from 'qs';

/** Raw query object from `qs.parse` — values may be string, string[], or nested objects per `qs` rules. */
export type ParsedAppQuery = Record<string, unknown>;

export function parseAppSearch(search: string): ParsedAppQuery {
  const trimmed = search.startsWith('?') ? search.slice(1) : search;
  const parsed = qs.parse(trimmed, { ignoreQueryPrefix: true, allowDots: false });
  return parsed as ParsedAppQuery;
}

export function stringifyAppQuery(query: ParsedAppQuery): string {
  const s = qs.stringify(query, { addQueryPrefix: true, skipNulls: true });
  return s === '?' ? '' : s;
}
